module.exports = __webpack_public_path__ + "static/PC-67e939311df69668ef98360bb09b83f3.png";